import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { getWeatherIcon } from "form/tools/schedule"
import React from "react"
import { WEATHERS } from "schedule/model"
import { FlexBox } from "ui/components/FlexBox"

interface ICampaignWeatherSummaryProps {
  weathers: WEATHERS[]
}

export const CampaignWeatherSummary = React.memo(({ weathers }: ICampaignWeatherSummaryProps) => {
  if (weathers.length === 0) {
    return (
      <Typography id="summary-weather-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
        {translate("label.preferred.weather.empty")}
      </Typography>
    )
  }
  return (
    <>
      {weathers.map((weather, index) => (
        <FlexBox
          id={`summary-weather-${index}`}
          key={index}
          vertical
          sx={{
            "gap": ".2rem",
            "& .weather-icon": {
              fontSize: "1.2rem",
              color: theme => theme.palette.text.primary
            }
          }}>
          <FontAwesomeIcon icon={getWeatherIcon(weather)} className="weather-icon" />
          <Typography fontSize=".8rem" color="textPrimary">
            {translate(`label.weather.${weather}`)}
          </Typography>
        </FlexBox>
      ))}
    </>
  )
})
